import { TestListContent } from './TestListContent';
export default TestListContent;